import styles from "../../styles/widgets/_button.scss";

Button.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  tabIndex: PropTypes.number,
  ariaLabel: PropTypes.string.isRequired
};

Button.defaultProps = {
  text: "",
  onClick: () => null,
  className: "",
  tabIndex: 0
};

export default function Button({
  text,
  onClick,
  className,
  tabIndex,
  ariaLabel
}) {
  return (
    <button
      className={`${styles.button} ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
    >
      {text}
    </button>
  );
}
